'use strict';
/* globals google */

const mapStyleOptions = require('./mapOptions');
const distanceUtils = require('../util/distance');

/**
 * gets open or closed date from opening hours string
 * @param {date} localDate localized date of today
 * @param {string} timeString open or close string with open/close hours
 * @returns {date} open/close date & time
 */
function getOpenHours(localDate, timeString) {
    const [hours, minutes] = timeString.split(':');

    var openDate = new Date(localDate);
    openDate.setHours(hours, minutes);

    return openDate;
}

/**
 * Converts am and pm to 24 hour format
 * @param {string} time - time to convert
 * @returns {string} - 24 hour format of time var
 */
function convert12To24HourFormat(time) {
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);

    var AMPM = time.match(/\s(.*)$/)[1];
    if ((AMPM === 'pm' || AMPM === 'PM') && hours < 12) {
        hours += 12;
    }
    if ((AMPM === 'am' || AMPM === 'AM') && hours === 12) {
        hours -= 12;
    }

    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) {
        sHours = '0' + sHours;
    }
    if (minutes < 10) {
        sMinutes = '0' + sMinutes;
    }

    return sHours + ':' + sMinutes;
}

/**
 * calculates if the store is currently open
 */
function calculateCurrentlyOpen() {
    var openMessage = $('.openingHours').data('message-open');
    var closeMessage = $('.openingHours').data('message-close');

    var storeIDs = $('.storeID, .store-detail');
    storeIDs.each(function (i, data) {
        var storeID = $('#' + $(data).attr('id').toString());

        var localTimeZone = storeID.find('.openingHours').data('time-zone');
        var hourFormat = storeID.find('.openingHours').data('hour-format');
        var localTime = new Date().toLocaleString('en-US', {
            timeZone: localTimeZone
        });
        var localDate = new Date(localTime);

        const days = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday'
        ];
        const day = days[localDate.getDay()];
        var openingshours = storeID.find('.' + day).data(day);
        if (openingshours) {
            var openTime = openingshours.open;
            var closeTime = openingshours.close;
            if ((openTime && openTime !== 'closed') && (closeTime && closeTime !== 'closed')) {
                // Check if the time contains split hours (e.g., "04:30-11:30 - 12:00-21:00")
                var splitPattern = /^.*-.*$/;
                if (splitPattern.test(openTime) || splitPattern.test(closeTime)) {
                    // Parse split hours: "04:30-11:30 - 12:00-21:00"
                    var timeRanges = [];
                    var combinedTime = [openTime, closeTime].filter(function (value) {
                        return value && value !== 'closed';
                    }).join(' - ');
                    var ranges = combinedTime.split(/\s+-\s+/);

                    ranges.forEach(function (rangeValue) {
                        var rangeTimes = rangeValue.split(/\s*-\s*/);
                        if (rangeTimes.length === 2) {
                            var rangeOpen = rangeTimes[0].trim();
                            var rangeClose = rangeTimes[1].trim();

                            if (!hourFormat) {
                                rangeOpen = convert12To24HourFormat(rangeOpen);
                                rangeClose = convert12To24HourFormat(rangeClose);
                            }

                            timeRanges.push({
                                open: rangeOpen,
                                close: rangeClose
                            });
                        }
                    });

                    // Check if current time falls within any of the time ranges
                    for (var j = 0; j < timeRanges.length; j++) {
                        var range = timeRanges[j];
                        var openDate = getOpenHours(localDate, range.open);
                        var closeDate = getOpenHours(localDate, range.close);

                        if (openDate <= localDate && closeDate > localDate) {
                            // Show the last closing time of the day
                            var lastCloseTime = timeRanges[timeRanges.length - 1].close;
                            storeID.find('.openinfotext').text(openMessage + ' ' + lastCloseTime);
                            return;
                        }
                    }
                } else {
                    // Handle single time range (original logic)
                    if (!hourFormat) {
                        openTime = convert12To24HourFormat(openTime);
                        closeTime = convert12To24HourFormat(closeTime);
                    }

                    if (closeTime) {
                        var singleOpenDate = getOpenHours(localDate, openTime);
                        var singleCloseDate = getOpenHours(localDate, closeTime);

                        if (singleOpenDate <= localDate && singleCloseDate > localDate) {
                            storeID.find('.openinfotext').text(openMessage + ' ' + openingshours.close);
                            return;
                        }
                    }
                }
            }
        }

        storeID.find('.openinfo').addClass('openinfoclosed');
        storeID.find('.circle').addClass('circleClosed');
        storeID.find('.openinfotext').text(closeMessage);
    });
}

/**
 * Sort stores by distance
 * @param {Object} a - fist element to sort
 * @param {Object} b - second element to sort
 * @returns {integer} -
 */
function sortAscending(a, b) {
    return parseInt($(a).find('.distance-result').text(), 10) - parseInt($(b).find('.distance-result').text(), 10);
}

/**
 *
 * @param {Object} position the current position of the client
 */
function calculateDistances(position) {
    var elements = document.getElementsByClassName('distance-result');
    $('.distance-text').removeClass('d-none');

    for (var i = 0; i < $('.distance-result').length; i++) {
        var distance = distanceUtils.getDistanceFromLatLon(
            position,
            parseFloat(elements[i].getAttribute('data-latitude')),
            parseFloat(elements[i].getAttribute('data-longitude'))
        );

        elements[i].innerHTML = $('html').data('country').toLowerCase() === 'us' ? distance.mi : distance.km;
    }

    // start to rearrange the tiles based on distance
    var storeLocatorResults = $('.store-locator-container .results');
    var pickupInStoreResults = $('.pickup-in-store-form .results');

    if (storeLocatorResults.length) {
        var sortedStores = storeLocatorResults.children().toArray().sort(sortAscending);
        storeLocatorResults.html('');
        storeLocatorResults.append(sortedStores);
    }
    if (pickupInStoreResults.length) {
        var sortedShops = pickupInStoreResults.children().toArray().sort(sortAscending);
        pickupInStoreResults.html('');
        pickupInStoreResults.append(sortedShops);
    }
}

/**
 * gets the position of the client
 */
function getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(calculateDistances);
    }
}

/**
 * Adds custom zoom buttons to the map
 * @param {Object} div Div that will be created
 * @param {Object} map Google Map that will be updated
 */
function zoomControl(div, map) {
    // Get the control DIV. We'll attach our control UI to this DIV.
    var controlDiv = div;

    controlDiv.className = 'zoomButtons';

    var zoomin = document.createElement('div');
    zoomin.title = 'Zoom in';
    controlDiv.appendChild(zoomin);

    var zoominText = document.createElement('div');
    zoominText.innerHTML = '<strong>+</strong>';
    zoomin.appendChild(zoominText);

    var zoomout = document.createElement('div');
    zoomout.title = 'Zoom out';
    controlDiv.appendChild(zoomout);

    var zoomoutText = document.createElement('div');
    zoomoutText.innerHTML = "<strong style='color:#2d2d2d;'>-</strong>";
    zoomout.appendChild(zoomoutText);

    // Setup the click event listeners for zoom-in, zoom-out:
    google.maps.event.addDomListener(zoomout, 'click', function () {
        var currentZoomLevel = map.getZoom();
        if (currentZoomLevel !== 0) {
            map.setZoom(currentZoomLevel - 1);
        }
    });

    google.maps.event.addDomListener(zoomin, 'click', function () {
        var currentZoomLevel = map.getZoom();
        if (currentZoomLevel !== 21) {
            map.setZoom(currentZoomLevel + 1);
        }
    });
}

/**
 *
 * @param {float} zoomLevel the default zoom level of the map
 * @param {Object} latlng the latitude and longitude of the client
 * @returns {Object} the map options
 */
function getMapOptions(zoomLevel, latlng) {
    return {
        zoom: zoomLevel,
        maxZoom: 17,
        center: latlng,
        gestureHandling: 'cooperative',
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        disableDefaultUI: true,
        styles: mapStyleOptions
    };
}

/**
 * handles generation and positioning markers
 * @param {Object} item - store object
 * @param {*} map - google maps item
 * @param {Object} markerImg - marker icon svg
 * @returns {*} marker
 */
function generateMapsMarker(item, map, markerImg) {
    var storeLocation = new google.maps.LatLng(
        item.latitude,
        item.longitude
    );
    var marker = new google.maps.Marker({
        position: storeLocation,
        map: map,
        title: item.name,
        icon: markerImg
    });

    return marker;
}

/**
 * Customized google map marker icon with svg format
 * @param {string} color - color of the marker
 * @returns {Object} Marker
 */
function markerImg(color) {
    var object = {
        path: 'M17.0347 11.5901C17.0347 14.7891 14.46 17.384 11.2841 17.384C8.10821 17.384 5.53356 14.7891 5.53356 11.5901C5.53356 8.39107 8.10821 5.79618 11.2841 5.79618C14.46 5.79389 17.0347 8.38878 17.0347 11.5901ZM23 11.5901C23 5.1875 17.853 0 11.5011 0C5.14929 0 0 5.1875 0 11.5901C0 14.4046 0.996855 16.9835 2.6515 18.9926L11.5102 31.871L20.4977 18.805C20.8209 18.3977 21.1171 17.9698 21.3838 17.519L21.4742 17.3885H21.4584C22.4371 15.6792 23 13.6999 23 11.5901Z',
        fillColor: color,
        fillOpacity: 1,
        width: 23,
        height: 32,
        fill: 'none',
        strokeWeight: 0,
        anchor: new google.maps.Point(13, 30),
        labelOrigin: new google.maps.Point(12, 12)
    };

    return object;
}

/**
 * Uses google maps api to render a map
 * @param {Object} centerPosition the latitude and longitude that will be used for the center
 * @param {string} radius the radius that will be used
 * @param {bool} openNearestShop boolean to indicate that the nearest shop should open on the map
 */
function maps(centerPosition, radius, openNearestShop) {
    var map;
    var infowindow = new google.maps.InfoWindow();
    var latlng;
    var zoomLevel = 4;

    if (centerPosition) {
        latlng = centerPosition;
        switch (radius) {
            case '15':
                zoomLevel = 11; // ~16 miles in map width
                break;
            case '30':
                zoomLevel = 10;
                break;
            case '50':
                zoomLevel = 9.2;
                break;
            case '100':
                zoomLevel = 8.4;
                break;
            case '300':
                zoomLevel = 6.5;
                break;
            default:
                zoomLevel = 11;
        }
    } else {
        var searchKeys = $('.store-locator-container .results').data('search-key');
        if (searchKeys && searchKeys.lat && searchKeys.long) {
            latlng = new google.maps.LatLng(searchKeys.lat, searchKeys.long);
            zoomLevel = 11;
        } else if ($('html').data('country').toLowerCase() === 'us') {
            // Init U.S. Map in the center of the viewport
            latlng = new google.maps.LatLng(37.09024, -95.712891);
        } else {
            // Init EU Map in the center of the viewport
            latlng = new google.maps.LatLng(50.8499966, -4.3499986);
        }
    }

    var mapOptions = getMapOptions(zoomLevel, latlng);
    map = new google.maps.Map($('.map-canvas')[0], mapOptions);

    // Loads custom zoom controls
    var zoomDiv = document.createElement('div');
    zoomControl(zoomDiv, map);
    zoomDiv.index = 1;
    map.controls[google.maps.ControlPosition.BOTTOM_RIGHT].push(zoomDiv);

    var bounds = new google.maps.LatLngBounds();

    if ($('.store-detail').data('store')) {
        var object = $('.store-detail').data('store');
        var marker = generateMapsMarker(object, map, markerImg('#cf7c58'));

        bounds.extend(marker.position);
        map.fitBounds(bounds);
    } else {
        var mapdiv = $('.map-canvas').attr('data-locations');
        mapdiv = JSON.parse(mapdiv);

        Object.keys(mapdiv).forEach(function (key) {
            var item = mapdiv[key];

            var marker = generateMapsMarker(item, map, markerImg('#503223'));

            marker.addListener('click', function () {
                infowindow.setOptions({
                    content: item.infoWindowHtml
                });
                infowindow.open(map, marker);
            });

            var searchKeys = $('.store-locator-container .results').data('search-key');
            if (openNearestShop && item.latitude === searchKeys.lat && item.longitude === searchKeys.long) {
                infowindow.setOptions({
                    content: item.infoWindowHtml
                });
                infowindow.open(map, marker);
            }

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);
        });

        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        if (mapdiv && mapdiv.length !== 0) {
            map.fitBounds(bounds);
        }
    }
}

/**
 * gets map function depending on open nearest state
 */
function createMapAndMarkers() {
    if ($('.store-locator-container').data('open-nearest')) {
        var searchKeys = $('.store-locator-container .results').data('search-key');
        if (searchKeys) {
            maps(new google.maps.LatLng(
                searchKeys.lat,
                searchKeys.long
            ), '', true);
        } else {
            maps();
        }
    } else {
        maps();
    }
}

/**
 * Initializes google map
 * @returns {boolean} retuns true if map is loaded
 */
function initMap() {
    if ($('.map-canvas').data('has-google-api')) {
        createMapAndMarkers();
        return true;
    }

    $('.store-locator-no-apiKey').show();
    return false;
}

module.exports = {
    calculateCurrentlyOpen: calculateCurrentlyOpen,
    getLocation: getLocation,
    initMap: initMap,
    maps: maps,
    calculateDistances: calculateDistances
};
